// ignore-string-externalization

import styled, { css } from 'styled-components';
import { Link } from '../ui';
import { screenMdMin, spacer32 } from '@spotify-internal/encore-web';

export interface ContentfulEntry {
  contentType: string;
  id: string;
  urlSlug: string;
}

export interface FaqArticle {
  question: string;
  urlSlug: string;
  answer: string;
  category?: FaqCategory;
  popular?: boolean;
  id: string;
  contentType: string;
  related?: ContentfulEntry[];
}

export interface FaqCategory {
  name: string;
  description?: string;
  urlSlug: string;
  faqs: FaqArticle[];
  icon?: { url?: string };
  id: string;
  contentType: string;
}

export const isHelpLive = true;

export const HELP_LIST_TRACK_CAT = 'Help List';
export const categoryTrackLabel = (category?: FaqCategory) =>
  `Category - ${category?.name || 'Unknown'}`;
export const articleTrackLabel = (article: FaqArticle) =>
  `Article - ${article.question}`;
const baseUrl = '/help';
export const categoryUrl = (category?: FaqCategory) =>
  `${baseUrl}${category ? `/${category.urlSlug}` : ''}`;
export const articleUrl = (article: FaqArticle, category?: FaqCategory) =>
  `${baseUrl}/article/${article.urlSlug}${
    category ? `?category=${category.urlSlug}` : ''
  }`;
export const LinkWithHelpHighlight = styled(Link)`
  &:hover,
  &:focus:not(:disabled),
  &:active:not(:disabled),
  &.highlight {
    color: ${({ theme }) => theme.help.link.hover};
  }

  &:focus:not(:hover),
  &:active:not(:hover),
  &.highlight:not(:hover) {
    color: ${({ theme }) => theme.box.text};
  }
`;
export const ChevronLink = styled(Link)`
  &:hover,
  &:focus:not(:disabled),
  &:active:not(:disabled),
  &.highlight {
    color: ${({ theme }) => theme.box.text};
  }
`;

export const hidden = css`
  visibility: hidden;
  height: 0;
  padding: 0;
  margin: 0;
`;

export const border = css`
  border-bottom: 1px solid ${({ theme }) => theme.help.link.divider};
`;

export const SearchBarContainer = styled.div`
  margin-bottom: ${spacer32};

  @media (min-width: ${screenMdMin}) {
    ${hidden}
  }
`;
